module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-inline pagination-wrapper"
  }, [(_vm.total === 0) ? _c('div', [_vm._v("\n    No entry\n  ")]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_vm._v("\n    Showing from " + _vm._s(_vm.start) + " to " + _vm._s(_vm.end) + " of " + _vm._s(_vm.total) + " entries\n  ")]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(!_vm.previousDisabled) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setCurrentPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("Prev")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPages), function(page) {
    return _c('li', {
      class: {
        'active': _vm.currentPage == page
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), (!_vm.nextDisabled) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setCurrentPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("Next")])]) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/template-compiler?{"id":"data-v-472d58bf"}!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/selector.js?type=template&index=0!./shared/components/table-pagination.vue
// module id = 85
// module chunks = 0